


<template lang="jade">

	div.mobile(
		v-if="$route.name !== 'trailer'"
		ref="mobileContent"
	)

		div.mobile-film(
			v-for="(film, index) in films"
			:id="`mobile-film-${index}`"
			:key="index"
		)

			div.mobile-title
				| {{ film.title.rendered }}

			a.mobile-poster(
				:href="film.acf.video"
				target="_blank"
				:style="`background: url(${film.acf.poster}) no-repeat center center; background-size: auto 100%;`"
			)

			div.mobile-credits-block(
				v-if="film.acf.credits"
			)
				div.mobile-credits-title(
					@click="toggleCredits(index)"
				) CREDITS

				div.mobile-credits-drawer(
					:class="{ 'mobile-credits-drawer-open' : credits.open.includes(index) }"
				)

					div.mobile-credits(
						:id="`mobile-credits-${index}`"
					)
						div.mobile-credits-credits(
							v-html="film.acf.credits_mobile"
						)

						div.mobile-credits-close(
							@click="toggleCredits(index)"
						) CLOSE

</template>



<script>



	const $cmp = {
		name : 'mobile',
		components : {}
	}



	$cmp.data = function() {
		return {
			credits : {
				open : []
			}
		}
	}



	$cmp.computed = {}

	$cmp.computed.films = function() {

		let $this = this
		let $pages = $this.$store.pages

		if ($pages.films) {
			return $pages.films.children
		} else {
			return $pages
		}

	}



	$cmp.mounted = function() {
		var $this = this
	}



	$cmp.methods = {}

	$cmp.methods.toggleCredits = function(num) {

		if (!this.credits.open.includes(num)) {

			this.credits.open.push(num)

		} else {

			let index = this.credits.open.indexOf(num)
			this.credits.open.splice(index, 1)

			let scrollTop = $('#mobile-film-' + num).get(0).offsetTop
			$(this.$refs.mobileContent).animate({
				scrollTop : scrollTop
			}, 555)

		}

	}



	export default $cmp



</script>



<style lang="stylus" scoped>

	.mobile
		position absolute
		top 115px
		left 0px
		right 0px
		bottom 100px
		z-index 4
		overflow hidden
		overflow-y auto

		@media(min-width 1024px)
			display none

	.mobile-film
		position relative
		margin-bottom 70px

	.mobile-title
		width 100%
		height 20px
		color #FFFFFF
		letter-spacing 1px
		margin-bottom 13px
		text-align center
		text-transform uppercase

	.mobile-poster
		display block
		width 100vw
		height 100vw
		margin-bottom 20px

	.mobile-credits-title
		display block
		color #FFFFFF
		font-size 11px
		letter-spacing 1px
		text-align center
		margin-bottom 20px
		cursor pointer

	.mobile-credits-drawer
		height 0px
		transition all 333ms
		overflow hidden

	.mobile-credits-drawer-open
		height auto

	.mobile-credits
		color #FFFFFF
		font-size 11px
		text-align center
		padding 0px 20px 0px 20px
		text-transform uppercase

	.mobile-credits-credits
		margin-bottom 20px

	.mobile-credits-credits strong
		font-family 'GTF Good Sans TRIAL', helvetica, sans-serif
		font-weight bold
		font-style normal

	.mobile-credits-close
		display block
		color #FFFFFF
		text-align center
		cursor pointer

</style>



// WEBPACK FOOTER //
// src/components/home/mobile.vue